import moment from 'moment';
import http from '../../../../utils/andromeda-api';

export const mapDeliveryRows = deliveryTableData =>
  deliveryTableData?.map(delivery => ({
    ...delivery,
    deliveryDate: moment.unix(delivery.deliveryDate).isValid()
      ? moment.unix(delivery.deliveryDate).format('MM-DD-YYYY hh:mm A')
      : 'N/A',
  })) || [];

export const fetchDeliveryEventsData = async ({
  messageId,
  search,
  orgId,
  channel,
}) => {
  const {
    data: { data },
  } = await http.get('/events/getMessageDeliveryEvents', {
    params: { messageId, search, orgId, channel },
  });

  return data;
};
